import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

interface PortalPageHeaderProps {
  title: string
  icon?: React.ReactNode
}

export const PortalPageHeader: FC<PortalPageHeaderProps> = ({
  title,
  icon,
}) => {
  return (
    <Typography
      variant="h5"
      sx={{
        mb: 3,
        color: colorTokens.text.primary,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {icon}
      {title}
    </Typography>
  )
}
